// Lib
import { createSelector } from 'reselect';

// Utils
import { createSmartSelector } from '../../utils/milanoteReselect/milanoteReselect';
import { getElementId } from '../../../common/elements/utils/elementPropertyUtils';
import { getChildrenViaGraph } from '../../../common/elements/utils/elementGraphUtils';
import { filterAndSortElementsInSection } from '../../../common/elements/utils/elementSortUtils';

// Selectors
import { getElements } from './elementsSelector';
import { elementGraphSelector } from './elementGraphSelector';

// Constants
import { BoardSections } from '../../../common/boards/boardConstants';

export const getElementChildren = () =>
    createSmartSelector(
        getElements,
        elementGraphSelector,
        (state, props) => props.originalElementId || props.elementId || getElementId(props.element),
        (elements, elementGraph, elementId) =>
            getChildrenViaGraph({
                elements,
                elementGraph,
                parentId: elementId,
            }),
    );

export const getElementChildrenSorted = (sortFn) =>
    createSelector(getElementChildren(), (children) =>
        filterAndSortElementsInSection({
            elements: children,
            section: BoardSections.INBOX,
            sortFn,
        }),
    );

export const getElementChildIdsSelector = () =>
    createSmartSelector(
        elementGraphSelector,
        (state, props) => props.elementId || getElementId(props.element),
        (elementGraph, elementId) => elementGraph[elementId],
    );

export const getElementChildIdsSorted = (sortFn) =>
    createSmartSelector(getElementChildrenSorted(sortFn), (sortedChildren) =>
        sortedChildren.map(getElementId).toArray(),
    );
